import { lazyLoad } from 'app/utils/loadable'

export const AccountInformationPage = lazyLoad(
  () => import('./index'),
  module => module.AccountInformationPage
)
